import React, { useState } from 'react';
import { Box, Card, CardContent, Typography, Button, Grid } from '@material-ui/core';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import moment from 'moment';

// Custom styles for the date picker
const datePickerStyles = `
  .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
    background-color: #f0f8ff !important;
    color: #272AEE !important;
  }
  .DayPicker-Day--start {
    background-color: #272AEE !important;
    color: white !important;
  }
  .DayPicker-Day--end {
    background-color: #272AEE !important;
    color: white !important;
  }
  .DayPicker-Day--selected:hover {
    background-color: #3538ef !important;
  }
  
  /* Fix z-index issues for calendar popup */
  .DayPickerInput-OverlayWrapper {
    z-index: 9999 !important;
  }
  
  .DayPickerInput-Overlay {
    z-index: 9999 !important;
    background: white !important;
    border: 1px solid #e8e8e8 !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    margin-top: 4px !important;
  }
  
  .DayPicker {
    z-index: 9999 !important;
  }
  
  /* Ensure input container has relative positioning */
  .DayPickerInput {
    position: relative !important;
    z-index: 1 !important;
  }
`;

const DateRangeFilter = ({ onDateRangeChange, onClear }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleStartDateChange = (date) => {
    setStartDate(date);
    if (date && endDate) {
      onDateRangeChange({
        startDate: moment(date).format('YYYY-MM-DD'),
        endDate: moment(endDate).format('YYYY-MM-DD')
      });
    }
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    if (startDate && date) {
      onDateRangeChange({
        startDate: moment(startDate).format('YYYY-MM-DD'),
        endDate: moment(date).format('YYYY-MM-DD')
      });
    }
  };

  const handleClear = () => {
    setStartDate(null);
    setEndDate(null);
    onClear();
  };

  const formatDate = (date) => {
    return date ? moment(date).format('MMM DD, YYYY') : '';
  };

  return (
    <React.Fragment>
      <style>{datePickerStyles}</style>
      <Card style={{ 
        marginBottom: '20px', 
        backgroundColor: '#f8f9fa', 
        border: '1px solid #e9ecef',
        overflow: 'visible',
        width: 'fit-content'
      }}>
        <CardContent style={{ padding: '16px', overflow: 'visible' }}>
          <Grid container spacing={2} alignItems="center" className="is-flex aic" style={{ overflow: 'visible', gap: '10px' }}>
            <Grid item>
              <Typography variant="subtitle2" style={{ 
                fontWeight: '600', 
                color: '#585858',
                marginBottom: '4px'
              }}>
                📅 Filter by Date Range (Date where brief was filled)
              </Typography>
            </Grid>
            
            <Grid item style={{ overflow: 'visible' }}>
              <Box display="flex" alignItems="center"style={{ overflow: 'visible', gap: '10px' }}>
                <div style={{ position: 'relative' }}>
                  <Typography variant="caption" style={{ 
                    display: 'block', 
                    marginBottom: '4px',
                    fontWeight: '500',
                    color: '#585858'
                  }}>
                    From Date
                  </Typography>
                  <DayPickerInput
                    value={startDate}
                    onDayChange={handleStartDateChange}
                    placeholder="Select start date"
                    format="MMM DD, YYYY"
                    formatDate={(date) => moment(date).format('MMM DD, YYYY')}
                    dayPickerProps={{
                      selectedDays: [startDate, { from: startDate, to: endDate }],
                      disabledDays: { after: endDate || new Date() },
                      toMonth: endDate || new Date(),
                      modifiers: {
                        start: startDate,
                        end: endDate,
                      },
                    }}
                    inputProps={{
                      readOnly: true,
                      style: {
                        height: '36px',
                        width: '150px',
                        border: '1px solid #e8e8e8',
                        borderRadius: '4px',
                        padding: '0 8px',
                        fontSize: '14px',
                        cursor: 'pointer',
                        backgroundColor: '#fff'
                      }
                    }}
                  />
                </div>

                <div style={{ position: 'relative' }}>
                  <Typography variant="caption" style={{ 
                    display: 'block', 
                    marginBottom: '4px',
                    fontWeight: '500',
                    color: '#585858'
                  }}>
                    To Date
                  </Typography>
                  <DayPickerInput
                    value={endDate}
                    onDayChange={handleEndDateChange}
                    placeholder="Select end date"
                    format="MMM DD, YYYY"
                    formatDate={(date) => moment(date).format('MMM DD, YYYY')}
                    dayPickerProps={{
                      selectedDays: [startDate, { from: startDate, to: endDate }],
                      disabledDays: { 
                        before: startDate,
                        after: new Date()
                      },
                      month: startDate || new Date(),
                      fromMonth: startDate,
                      modifiers: {
                        start: startDate,
                        end: endDate,
                      },
                    }}
                    inputProps={{
                      readOnly: true,
                      style: {
                        height: '36px',
                        width: '150px',
                        border: '1px solid #e8e8e8',
                        borderRadius: '4px',
                        padding: '0 8px',
                        fontSize: '14px',
                        cursor: 'pointer',
                        backgroundColor: '#fff'
                      }
                    }}
                  />
                </div>

                {(startDate || endDate) && (
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleClear}
                    style={{
                      marginTop: '30px',
                      borderColor: '#bb4c4c',
                      color: '#bb4c4c',
                      fontSize: '12px',
                      padding: '4px 12px'
                    }}
                  >
                    Clear Filter
                  </Button>
                )}
              </Box>
            </Grid>

            {startDate && endDate && (
              <Grid item xs={12}>
                <Box 
                  mt={1} 
                  p={1} 
                  style={{ 
                    backgroundColor: '#e8f5e8', 
                    borderRadius: '4px',
                    border: '1px solid #67b96b'
                  }}
                >
                  <Typography variant="caption" style={{ 
                    color: '#48994c',
                    fontWeight: '500'
                  }}>
                    📊 Showing videos from {formatDate(startDate)} to {formatDate(endDate)}
                  </Typography>
                </Box>
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>
    </React.Fragment>
  );
};

export default DateRangeFilter;
